import PatientDataSummaryLabelMobile from "./PatientDataSummaryLabelMobile";
export default PatientDataSummaryLabelMobile;
